import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Image from '@/components/base/Image'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'

import { opacityReveal } from './animations/opacity'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type HeroProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title: string
    description: string
    image: WPImage
  }>

const Hero = ({ title, description, image }: HeroProps) => {
  return (
    <Motion animation={opacityReveal}>
      <section className="h-svh-vh relative text-white" data-hero>
        {image?.url ? (
          <div className="absolute inset-0 -z-10 bg-black">
            <div
              className={cn(
                'absolute inset-0 transition-opacity duration-1000 ease-out-cubic'
              )}
            >
              <Image source={image} alt={title} size="full" fit="cover" fill />
            </div>
          </div>
        ) : null}
        <Container className="h-full bg-black/30">
          <Grid className="h-full items-end pb-[66px]">
            <div className={cn('col-span-4', 'md:col-span-4', 'lg:col-span-6')}>
              <div className="flex flex-col gap-[15px]">
                {title ? <Typography variant="h4">{title}</Typography> : null}
                {description ? (
                  <Typography variant="body">{description}</Typography>
                ) : null}
              </div>
            </div>
          </Grid>
        </Container>
      </section>
    </Motion>
  )
}

export default Hero
